import { useGetEventTeamResultsByMemberQuery } from '../state/api';
import TeamCompetitionCompetitors from './team-competition-competitors';

interface TeamCompetitionCompetitorsContainerProps {
  teamCompID: string | undefined;
}

const TeamCompetitionCompetitorsContainer = ({ teamCompID }: TeamCompetitionCompetitorsContainerProps) => {
  const { data: results = [] } = useGetEventTeamResultsByMemberQuery(teamCompID!, {
    skip: teamCompID === undefined,
  });

  return <TeamCompetitionCompetitors results={results} />;
};

export default TeamCompetitionCompetitorsContainer;
